import { DateFormatter } from "../utils";


export const PAYROLL_TYPES = [
    {label: "Sindicato", value: "Sindicato"},
    {label: "Confianza", value: "Confianza"},
    {label: "Quincena", value: "Quincena"},
]

export const payrollDates = (() => {
    const today = new Date();
    const ranges = {};
    // const current = new Date(today.getFullYear() - 1, 0, 1); 
    const current = new Date(2024 , 0, 1); 

    while(current < today){ //Mientras no sobrepase la fecha actual
        const year = current.getFullYear(); 
        const month= current.getMonth();

        if (!ranges[year]) ranges[year] = [];

        const periods = [
            {start: new Date(year, month, 1), end: new Date(year, month, 15)},
            {start:  new Date(year, month, 16), end: new Date(year, month + 1, 0)}
        ]

        periods.forEach(p => {
            if (p.end <= today) {
                const label = `${DateFormatter(p.start, 'SHORT_LABEL')} - ${DateFormatter(p.end, 'SHORT_LABEL')}`

                ranges[year].push({
                    label: label,
                    value: JSON.stringify({
                        start: p.start.toISOString().split('T')[0],
                        end: p.end.toISOString().split('T')[0]
                    })
                });
            }
        });

        current.setMonth(current.getMonth() + 1);
    }

    return Object.keys(ranges)
        .sort((a, b) => b - a)
        .flatMap(year => 
            ranges[year].sort((a, b) => b.value.localeCompare(a.value))
        );
})();

export const filterPayroll = (data, selectedDate, selectedType, search="") => {
    if (!data) return [];

    const q = search.trim().toLowerCase();

    return data.filter(item => {
        if (selectedDate) {
            const {start, end} = JSON.parse(selectedDate);

            const dateObj = new Date(item.fecha);

            if (!isNaN(dateObj.getTime())) {
                const date = dateObj.toISOString().split('T')[0];
                if(!(date >= start && date <= end)) return false;
            }
        }

        if (selectedType && item.tipoNomina !== selectedType) return false;

        if (q && !item.nombre.toLowerCase().includes(q)) return false;

        return true;
    })
}